import BtnClear from "./btn-clear";
import React, { useState } from "react";
import inpSetts from "../../../settings/params-settings";
const maxSokolLyon = inpSetts.IndSokolLyon.max_mV;
const minSokolLyon = inpSetts.IndSokolLyon.min_mV;
const IndexSokolovEditor = ({ loc, onChanged, data: { indexSokolovLyon } }) => {
    const _val = indexSokolovLyon === null || indexSokolovLyon === undefined || isNaN(indexSokolovLyon) ? "" : indexSokolovLyon;
    const [inputVal, setVal] = useState("");
    if (_val !== inputVal) setVal(_val);
    const indexSokolovID = "edit.indexSokolovLyon";
    return (
        <div className="ctrl-input-group-ST">
            <label className="Zone-label" htmlFor={indexSokolovID}>
                {loc("report.params.indexSokolovLyon")}
            </label>
            <input
                type="number"
                id={indexSokolovID}
                className="ctrl-input"
                min={minSokolLyon}
                max={maxSokolLyon}
                step="0.1"
                value={_val}
                onChange={e => {
                    setVal(e.target.value);
                    onChanged(indexSokolovID, { indexSokolovLyon: +e.target.value });
                }}
            />
            <span className="ctrl-units">{loc("units.mV")}</span>
            <BtnClear
                onClick={e => {
                    setVal("");
                    onChanged(indexSokolovID, { indexSokolovLyon: "" });
                }}
            />
        </div>
    );
};

export default IndexSokolovEditor;
